import React from 'react';
import { useParams } from 'react-router-dom';

export default function BookingCompletion() {
  const { token } = useParams();

  return (
    <div className="min-h-screen bg-[#FAFAF9] py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-center mb-8">
          <span className="font-serif tracking-wide whitespace-nowrap text-3xl md:text-4xl text-[#1C1917]" data-testid="brand-name">Acqualina Resort</span>
        </div>

        <div className="bg-white border border-[#E7E5E4] shadow-sm rounded-sm p-8 text-center">
          <h2 className="text-3xl font-serif text-[#1C1917] mb-4">Complete Your Booking</h2>
          <p className="text-[#78716C] mb-6">
            This feature allows staff-initiated bookings to be completed by guests.
          </p>
          <p className="text-sm text-[#A8A29E]">
            Token: {token}
          </p>
        </div>
      </div>
    </div>
  );
}
